import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "../atoms/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, } from "../atoms/dialog";
import { cn } from "../../lib/cn";
/**
 * The confirmation step in front of an irreversible action.
 *
 * Two decisions worth keeping. First, cancel comes SECOND in the DOM but
 * renders first visually, via `flex-col-reverse` in `DialogFooter`: keyboard
 * order reaches the safe option first while the primary action sits where the
 * eye expects it. Second, the confirm button is not autofocused. Radix focuses
 * the dialog itself, so the user reads before they can press anything.
 *
 * The label should name the action ("Delete site"), not agree with the
 * question ("Yes"). Someone tabbing through hears the button, not the prose.
 */
export function ConfirmDialog({ open, onOpenChange, title, description, children, confirmLabel = "Confirm", cancelLabel = "Cancel", onConfirm, destructive = false, pending = false, className, }) {
    return (_jsx(Dialog, { open: open, onOpenChange: onOpenChange, children: _jsxs(DialogContent, { "data-slot": "confirm-dialog", className: cn("lg:max-w-md", className), ...(pending
                ? {
                    onEscapeKeyDown: (event) => {
                        event.preventDefault();
                    },
                    onInteractOutside: (event) => {
                        event.preventDefault();
                    },
                }
                : {}), children: [_jsxs(DialogHeader, { children: [_jsx(DialogTitle, { children: title }), description !== undefined && _jsx(DialogDescription, { children: description })] }), children, _jsxs(DialogFooter, { children: [_jsx(Button, { variant: "outline", disabled: pending, onClick: () => {
                                onOpenChange(false);
                            }, children: cancelLabel }), _jsx(Button, { variant: destructive ? "destructive" : "primary", disabled: pending, onClick: onConfirm, children: confirmLabel })] })] }) }));
}
//# sourceMappingURL=confirm-dialog.js.map